module.exports = __webpack_public_path__ + "img/icono-12-1.3fa77039.png";